import {setupTextAreas} from "../../global/all";
import {showErrorNotification, showSuccessNotification} from "../../global/notifications";
import assetTransfer from "./asset-transfer";
import {createAssetGrid} from "./asset-management-grid";
import {EventTypes} from "../../../constants/event-types";

const saveDeviceDetailsSuccess = function (e) {
    if (e.success) {
        showSuccessNotification(e.message);
        // loadDetailView($('.js-device-details'), {});
        return;
    }
    showErrorNotification(e.message);
    // return reject(e);
};
const saveDeviceDetails = function (e) {
    const deviceWrapper = $('#device-details');
    const deviceData = $(deviceWrapper).data();
    const url = `/Technology/AssetManagement/SaveDeviceDetails`;
    const data = {
        type: deviceData.deviceType,
        deviceId: deviceData.deviceId
    };

    deviceWrapper.find('[id]').not('button').each((a, o) => {
        const ele = $(o);
        if (ele.hasClass('k-checkbox'))
            data[ele.attr('id')] = ele.is(':checked');
        else data[ele.attr('id')] = ele.val();
    });

    $.post(
        url,
        data,
        saveDeviceDetailsSuccess
    ).then(() => {
        loadDetailView($('.js-device-details'), data);
    });
};

function showDeviceDetails(e, show = true) {
    const $detailsSection = $('.js-device-details');
    $detailsSection.html('<div class="spinner" id="loading"><span class="spinner__text">Loading Details...</span></div>');
    $detailsSection.toggle(show);
    if (show) {
        const thisDevice = $(e.currentTarget);
        loadDetailView($detailsSection, thisDevice.data());
    }
}

const loadDetailView = ($detailsSection, deviceData) => {
    destroyOldTransferWindow();
    $detailsSection.load('/Technology/AssetManagement/DeviceDetails',
        deviceData,
        function (e) {
            setupTextAreas();
            $('.js-status').kendoDropDownList();
            $('.js-location').kendoTextBox();
            $('.k-icon.k-i-close').bind('click', function (e) {
                $.event.trigger(EventTypes.OpenTechDetails, [e, false]);
            });
            const $deviceWindow = $('#device-hx-window');
            const k_window = $deviceWindow.data('kendoWindow');
            if (k_window) return;
            const k_hxWindow = $deviceWindow.kendoWindow({
                actions: ['Minimize', 'Close'],
                draggable: true,
                resizable: true,
                width: '500px',
                title: 'Device History',
                visible: false
            }).data('kendoWindow');
            k_hxWindow.element.parent().css('top', '').css('left', '').addClass('centerWindow');
            $('#view-full-hx').bind('click', function (e) {
                k_hxWindow.open();
            });
            $('#save-device').bind('click', saveDeviceDetails);
            setUpTransferWindow();
        });
}

const destroyOldTransferWindow = () => {
    const k_oldTransferWindow = $('#device-transfer-window').data('kendoWindow');
    if (k_oldTransferWindow) k_oldTransferWindow.destroy();
}
const setUpTransferWindow = () => {
    const $deviceTransferWindow = $('#device-transfer-window');
    const k_transferWindow = $deviceTransferWindow.kendoWindow({
        actions: ['Minimize', 'Close'],
        draggable: true,
        resizable: true,
        width: '500px',
        title: 'Transfer Device',
        visible: false,
        position: {
            top: 50,
            left: 50
        }
    }).data('kendoWindow');

    //Center Window
    k_transferWindow.element.parent().css('top', '').css('left', '').addClass('centerWindow');

    //Add Event to open Window
    $('#open-transfer-device').bind('click', function (e) {
        k_transferWindow.open();
    });

    assetTransfer($('#device-details').data());
};

const setupKaceExport = () => {
    $('#kaceExport').kendoButton({
        themeColor: 'primary'
    });
};

export default function (nameAction, namePage) {
    createAssetGrid();
    $(document).bind(EventTypes.OpenTechDetails, function (event, passedEvent, show) {
        showDeviceDetails(passedEvent, show);
    })
    setupKaceExport();
};